
export default {
  name: 'rb-header-base-product-slide',
  props: {
    url: {
      type: String,
      default: '',
    },
    image: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    analyticsElementId: {
      type: String,
      default: '',
    },
  },
}
